module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Filters')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-392becf2!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/frontfilter/App.vue
// module id = 167
// module chunks = 1